import { Checkbox as BSCheckbox } from 'react-bootstrap';
import styled, { css } from 'styled-components';

export const BSCheckboxStyled = styled(BSCheckbox)<{ $required?: boolean }>`
  ${({ $required }) =>
    $required &&
    css`
      &::after {
        content: '*';
        color: #a94442;
        margin-left: 4px;
        font-weight: 600;
      }
    `}
`;
